import { ERP_NAMES } from '@/domain/companies/helpers';

export const settingsTypes = Object.freeze({
  boolean: 'boolean',
  text: 'text',
  list: 'list',
  dynamic_list: 'dynamic_list',
  file: 'file',
  float: 'float',
  number: 'number',
  int: 'int',
  ftp_connection: 'ftp_connection',
  indexes_sync_time: 'indexes_sync_time',
  priority_customer_api_connection: 'priority_customer_api_connection',
});

export const erpNamesList = Object.values(ERP_NAMES);
